class PredictiveSearch extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    if (this.els.input.element.value.trim().length) {
      this.showResults(true)

      this.getSearchResults(this.els.input.element.value.trim())
    }
  }

  setupListeners () {
    super.setupListeners()

    this.onInputChange = this.onInputChange.bind(this)
    this.handleDrawerTrigger = this.handleDrawerTrigger.bind(this)

    this.listeners.add(
      this.els.input.element,
      'input',
      window.BAO.Utils.debounce((e) => {
        this.onInputChange(e)
      }, 500),
    )

    this.externalEls.trigger.elements.forEach((triggerEl) => {
      this.listeners.add(triggerEl, 'click', this.handleDrawerTrigger)
    })
  }

  onInputChange () {
    const searchTerm = this.els.input.element.value.trim()

    if (searchTerm.length) {
      this.showResults(true)

      this.getSearchResults(searchTerm)
    } else {
      this.showResults(false)
    }
  }

  getSearchResults (searchTerm) {
    fetch(
      `${window.Shopify.routes.root}search/suggest?q=${searchTerm}&resources[limit]=6&resources[limit_scope]=each&resources[options][fields]=body,product_type,tag,title,variants.barcode,variants.sku,variants.title,vendor&section_id=predictive-search`,
    )
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement('div')
        html.innerHTML = text

        const productResults = html.querySelector(
          '#predictive-search-products',
        )
        const queriesResults = html.querySelector('#predictive-search-queries')
        const collectionResults = html.querySelector(
          '#predictive-search-collections',
        )

        this.handleProductResults(productResults, searchTerm)
        this.handleQueriesResults(queriesResults)
        this.handleCollectionResults(collectionResults)
      })
      .catch((e) => {
        console.error(e)
      })

    window.BAO.sectionRenderer
      .fetch(
        'section-search-count',
        `${window.Shopify.routes.root}search?q=${searchTerm}&type=product&view=count`,
      )
      .then((res) => {
        const newDOM = window.BAO.sectionRenderer.convertToDOM(
          res['section-search-count'],
        )
        const myself = newDOM.querySelector('.shopify-section')

        this.els['products-count'].element.textContent = myself.innerText
      })
      .catch(() => {})
  }

  showResults (state) {
    this.els.queries.element.setAttribute('aria-hidden', state === false)
    this.els.products.element.setAttribute('aria-hidden', state === false)
    this.els.collections.element.setAttribute('aria-hidden', state === false)
    this.els.default.element.setAttribute('aria-hidden', state === true)
  }

  handleProductResults (results, searchTerm) {
    if (results) {
      this.els['products-grid'].element.innerHTML = results.innerHTML
      this.els['products-link'].element.setAttribute(
        'aria-hidden',
        results.dataset.resultCount === '0',
      )
      this.els['products-link'].element.href =
        `/search?q=${searchTerm}&resources[type]=product`
      this.els['showing-products'].element.innerText =
        results.dataset.resultCount
    }
  }

  handleQueriesResults (results) {
    if (results) {
      this.els.queries.element.innerHTML = results.innerHTML

      this.els.queries.element.setAttribute(
        'aria-hidden',
        results.dataset.resultCount === '0',
      )
    }
  }

  handleCollectionResults (results) {
    if (results) {
      this.els.collections.element.innerHTML = results.innerHTML

      this.els.collections.element.setAttribute(
        'aria-hidden',
        results.dataset.resultCount === '0',
      )
    }
  }

  handleDrawerTrigger () {
    // Align temp input element approximately where the input element is
    // so the cursor doesn't jump around
    const tempInputEl = document.createElement('input')
    tempInputEl.style.position = 'absolute'
    tempInputEl.style.top = `${this.els.input.element.offsetTop + 7}px`
    tempInputEl.style.left = `${this.els.input.element.offsetLeft}px`
    tempInputEl.style.height = 0
    tempInputEl.style.opacity = 0
    // Put this temp element as a child of the page <body> and focus on it
    document.body.appendChild(tempInputEl)
    tempInputEl.focus()

    // The keyboard is open. Now do a delayed focus on the target element
    window.setTimeout(() => {
      this.els.input.element.focus()
      this.els.input.element.click()
      // Remove the temp element
      document.body.removeChild(tempInputEl)
    }, 500)

    const searchTerm = this.els.input.element.value.trim()

    if (searchTerm.length) {
      this.showResults(true)

      this.getSearchResults(searchTerm)
    } else {
      this.showResults(false)
    }
  }
}

if (!customElements.get('predictive-search')) {
  customElements.define('predictive-search', PredictiveSearch)
}
